import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Switch, Tag, TagLabel, Spinner } from '@chakra-ui/react';
import updatePublishStatusAction from 'store/modules/common/publishEntity/publishEntity-action';
import { ReducerStatus } from 'utils/constants';

function PublishButton({ entityType, entityId, isPublished, ...rest }) {
  const dispatch = useDispatch();

  const publishState = useSelector(
    (state) =>
      state.publishEntity.updatePublishEntity.status &&
      state.publishEntity.updatePublishEntity.currentEntityId === entityId &&
      state.publishEntity.updatePublishEntity.currentEntityType === entityType
  );

  const publishStatus = useSelector(
    (state) => state.publishEntity.updatePublishEntity.status
  );

  const handleToggle = () => {
    dispatch(
      updatePublishStatusAction({
        entityType,
        entityId,
        isPublished: !isPublished,
      })
    );
  };

  return (
    <Tag bg={isPublished ? 'green.500' : 'blue.500'} variant="solid" {...rest}>
      {publishState ? (
        <Spinner size="sm" mr={2} />
      ) : (
        <Switch
          size="sm"
          colorScheme="whatsapp"
          isChecked={isPublished}
          onChange={handleToggle}
          isDisabled={publishStatus === ReducerStatus.LOADING}
          mr={2}
        />
      )}
      <TagLabel>{isPublished ? 'Published' : 'Draft'}</TagLabel>
    </Tag>
  );
}

PublishButton.defaultProps = {
  isPublished: false,
  isLoading: false,
  entityType: null,
  entityId: null,
};

PublishButton.propTypes = {
  entityType: PropTypes.oneOf([
    'Course',
    'Quest',
    'SubQuest',
    'LearningPlan',
    'Class',
  ]),
  entityId: PropTypes.number,
  isPublished: PropTypes.bool,
  isLoading: PropTypes.bool,
};

export default PublishButton;
